// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { createAsyncAction } from 'typesafe-actions';

export interface DeleteFavoriteRequestPayload {
  condition: string;
  id: number;
  success: Function;
}
export interface DeleteFavoriteSuccessPayload {}

export interface DeleteFavoriteFailPayload {
  error: Error;
}

export const deleteFavoritesActions = createAsyncAction(
  'elearning/DELETE_FAVORITE',
  'elearning/DELETE_FAVORITE_SUCCESS',
  'elearning/DELETE_FAVORITE_FAIL'
)<
  DeleteFavoriteRequestPayload,
  DeleteFavoriteSuccessPayload,
  DeleteFavoriteFailPayload
>();
